Customer.Ticket ||= {}

class Customer.Ticket.PrivacySelectorView extends Backbone.View
  template: JST["backbone/templates/customer/ticket/header/privacy_selector"]

  events:
    'change #privacy-selector': 'onChangePrivacySelector'

  initialize: (@options = {}) ->
    @selectedPrivacy = @options.selectedPrivacy || 'all'

  render: ->
    @$el.html(@template(selectedPrivacy: @selectedPrivacy))
    @$el.find('#privacy-selector').chosen(width: '110px', disable_search: true)
    @

  onChangePrivacySelector: (evt) =>
    selectedOption = evt.currentTarget.value
    @trigger('change:privacySelector', selectedOption)
